import ApiService from "./api.service";
export default class GeneralSettingService extends ApiService {
    static base_url = `${super.base_url}/general_settings`;
}
